function utf8_to_b64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}

function b64_to_utf8(str) {
  return decodeURIComponent(escape(window.atob(str)));
}

console.log('parsing jwt tokens check');
if (window.location.hash) {
  var s = window.location.hash;
  var i = s.indexOf('header=');
  var j = s.indexOf(',');
  if (i != -1 && j != -1) {
    var b64 = s.substring(i + 7, j);
    console.log('b64=' + b64);
    var json = b64_to_utf8(b64);
    console.log('json=' + json);
    var header = JSON.parse(json);
    console.log(header);
    localStorage.setItem('logged-in-name', header['logged-in-name']);
    localStorage.setItem('logged-in-id', header['logged-in-id']);
    localStorage.setItem('logged-in-nationality', header['logged-in-nationality']);
    localStorage.setItem('logged-in-extra-link', header['logged-in-extra-link']);
    localStorage.setItem('logged-in-total-balance', header['logged-in-total-balance']);
    localStorage.setItem('info', header['info']);
    setRefCookie('aid', header['aid']);
    setRefCookie('ref', header['ref']);
    setRefCookie('refNote', header['refNote']);
    setRefCookie('blog', header['blog']);
    setRefCookie('post', header['post']);
    currentCurrency = header['currency'];
    if (!isCurrencyValid(currentCurrency)) {
      currentCurrency = 'USD';
    }
    createCookie('currency', currentCurrency, 1, true, accessTokenDomain);
  }

  var jwt = '';
  var k = s.indexOf('jwt=');
  console.log('parsing jwt tokens check k=' + k + ' s=' + s);

  if (k != -1) {
    jwt = s.substring(k + 4);
    console.log('parsing jwt tokens check jwt=' + jwt);
    var date = new Date();
    date.setTime(date.getTime() + (5 * 60 * 1000)); // 5 min expire of cookie. JWT Token is 2min
    console.log('setting tmpUserToken: ' + jwt);
    document.cookie = "tmpUserToken=" + jwt + "; expires=" + date.toGMTString() + "; Path=/; Secure" + (accessTokenDomain.length > 0 ? ("; Domain=" + accessTokenDomain) : "");
  }
}

function setRefCookie(name, value) {
  if (value != null) {
    createCookie(name, value, 30, 1, accessTokenDomain);
  }
}


function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function createCookie(name, value, days, secure, domain) {
  secure = true;

  if (location.protocol !== 'https:') {
    secure = false;
  }

  if (typeof domain === 'undefined') {
    domain = '';
  }

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; Expires=" + date.toGMTString();
  } else var expires = "";

  document.cookie = name + " = " + value + expires + "; Path=/" + (secure ? "; Secure" : "") + (domain.length > 0 ? ("; Domain=" + domain) : "");
}

function eraseCookie(name) {
  createCookie(name, '', -1);
}

var geoLocation = readCookie('GEO_LOCATION');
if (geoLocation == 'GB') {
  geoLocation = 'UK';
}

eraseCookie('GEO_LOCATION');

function getGeoCountry() {
  return geoLocation;
}

function getLocationCountry() {
  return locationShortName;
}

function isEUCountry(country) {
  if (country == "AT" ||
    country == "BE" ||
    country == "BG" ||
    country == "CY" ||
    country == "CZ" ||
    country == "DK" ||
    country == "EE" ||
    country == "FI" ||
    country == "FR" ||
    country == "DE" ||
    country == "GR" ||
    country == "HU" ||
    country == "IE" ||
    country == "IT" ||
    country == "LV" ||
    country == "LT" ||
    country == "LU" ||
    country == "MT" ||
    country == "NL" ||
    country == "PL" ||
    country == "PT" ||
    country == "RO" ||
    country == "SK" ||
    country == "SI" ||
    country == "ES" ||
    country == "SE" ||
    country == "GB" ||
    country == "UK") {
    return true;
  } else {
    return false;
  }
}

var currentCurrency = readCookie('currency');
if (!currentCurrency || currentCurrency.length == 0) {
  if (geoLocation == 'SG' || geoLocation == 'MY' || geoLocation == 'ID') {
    currentCurrency = 'SGD'
  } else if (geoLocation == 'AU') {
    currentCurrency = 'AUD';
  } else if (geoLocation == 'JP') {
    currentCurrency = 'JPY';
  } else if (geoLocation == 'SE') {
    currentCurrency = 'SEK';
  } else if (geoLocation == 'NZ') {
    currentCurrency = 'NZD';
  } else if (geoLocation == 'UK' || geoLocation == 'GB') {
    currentCurrency = 'GBP';
  } else if (isEUCountry(geoLocation)) {
    currentCurrency = 'EUR';
  } else {
    currentCurrency = 'USD';
  }

  if (!isCurrencyValid(currentCurrency)) {
    currentCurrency = 'USD';
  }

  createCookie('currency', currentCurrency, 1, true, accessTokenDomain);
}

function isCurrencyValid(cur) {
  if (typeof cur === 'undefined') {
    return false;
  }

  return cur == 'SGD' ||
    cur == 'USD' ||
    cur == 'EUR' ||
    cur == 'GBP' ||
    cur == 'AUD' ||
    cur == 'NZD' ||
    cur == 'SEK' ||
    cur == 'JPY' ||
    cur == 'BTC' ||
    cur == 'BCH' ||
    cur == 'ETH' ||
    cur == 'LTC';
}

function getCurrency() {
  if (!isCurrencyValid(currentCurrency)) {
    createCookie('currency', 'USD', 1, true, accessTokenDomain);
    currentCurrency = 'USD';
  }

  return currentCurrency;
}

function setCurrency(currency) {
  if (currency) {
    currentCurrency = currency;
    createCookie('currency', currentCurrency, 1, true, accessTokenDomain);
  }
}

function getCurrencySigns() {
  var signs = [{
      code: 'USD',
      sign: 'US$'
    },
    {
      code: 'EUR',
      sign: '€'
    },
    {
      code: 'SGD',
      sign: 'S$'
    },
    {
      code: 'JPY',
      sign: '¥'
    },
    {
      code: 'GBP',
      sign: '£'
    },
    {
      code: 'AUD',
      sign: 'AU$'
    },
    {
      code: 'SEK',
      sign: 'kr'
    },
    {
      code: 'NZD',
      sign: 'NZ$'
    },
  ];

  return signs;
}

function getCurrencySign(code) {
  var currency = getCurrencySigns().filter((item) => {
    return item.code == code;
  });

  return currency[0]?.sign ?? code;
}

function getQueryParam(name) {
  var url = window.location.href;
  var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(url);
  if (!results) {
    return null;
  }
  return results[1] || null;
}

function getAccountIdParam() {
  var aId = getQueryParam('accountId');
  if (aId) {
    console.log('accountIdParam is ' + aId);
  }
  return aId;
}

function showBestPriceBanner() {
  return window.location.pathname !== '/buy/numismatics-collectibles-gold-coins' &&
    window.location.pathname !== '/buy/jewellery' &&
    window.location.pathname !== '/buy/numismatics-collectibles-silver-coins' &&
    window.location.pathname !== '/buy/supplies'
}

function isNewCustomer() {
  var firstVisit = localStorage.getItem('firstVisit') * 1000;
  var now = Date.now();
  var visit = firstVisit ? parseInt(firstVisit) : now;
  var diff = now - parseInt(visit);

  var diffDays = diff / (24 * 60 * 60 * 1000);
  console.log('isNewCustomer: visit: ' + visit + ' now: ' + now + ' diff: ' + diff + ' diffDays: ' + diffDays);
  return diffDays < 5;
}

function formatTimeSince(date) {

  var seconds = Math.floor((new Date() - date) / 1000);
  interval = Math.floor(seconds / 604800);
  if (interval == 1) {
    return interval + ' week ago';
  }
  if (interval > 1) {
    return interval + ' weeks ago';
  }
  interval = Math.floor(seconds / 86400);
  if (interval == 1) {
    return interval + ' day ago';
  }
  if (interval > 1) {
    return interval + ' days ago';
  }
  interval = Math.floor(seconds / 3600);
  if (interval == 1) {
    return interval + ' hour ago';
  }
  if (interval > 1) {
    return interval + ' hours ago';
  }
  interval = Math.floor(seconds / 60);
  if (interval == 1) {
    return interval + ' minute ago';
  }
  if (interval > 1) {
    return interval + ' minutes ago';
  }
  return Math.floor(seconds) + ' seconds ago';
}

function printCurrencyName(cur) {
  var str = 'US Dollar';
  if (cur == 'SGD') {
    str = 'Singapore Dollar';
  } else if (cur == 'EUR') {
    str = 'Euro';
  } else if (cur == 'JPY') {
    str = 'Japanese Yen';
  } else if (cur == 'AUD') {
    str = 'Australian Dollar';
  } else if (cur == 'SEK') {
    str = 'Swedish Krona';
  } else if (cur == 'NZD') {
    str = 'New Zealand Dollar';
  } else if (cur == 'GBP') {
    str = 'British Pound';
  } else if (cur == 'BTC') {
    str = 'Bitcoin';
  } else if (cur == 'BCH') {
    str = 'Bitcoin Cash';
  } else if (cur == 'ETH') {
    str = 'Ethereum';
  } else if (cur == 'LTC') {
    str = 'Litecoin';
  } else if (cur == 'XDG') {
    str = 'Dogecoin';
  }
  return str;
}